(function() {
  'use strict';
  // ====== CALCULADORA INLINE V2 ======
  const calcRoot = document.querySelector('.pf-calc');
  if (!calcRoot) return;

  const calcType = calcRoot.dataset.calcType || 'cubos';
  const bagKg = parseFloat(calcRoot.dataset.bagKg || '1');
  const variantId = calcRoot.dataset.variantId || '';
  const productUrl = calcRoot.dataset.productUrl || '';
  const WA = (calcRoot.dataset.wa || '').replace(/\D/g, '');

  // Parámetros por tipo de hielo
  const params = {
    cubos:  { kgPerPerson: 0.5, cubesPerGlass: 3, gramsPerCube: 50 },
    frappe: { kgPerPerson: 0.4, cubesPerGlass: 1, gramsPerCube: 150 },
    picado: { kgPerPerson: 0.35, cubesPerGlass: 1, gramsPerCube: 120 }
  };
  const cfg = params[calcType] || params.cubos;

  const peopleInput = calcRoot.querySelector('[data-calc-target="people"] .pf-calc__value');
  const glassesInput = calcRoot.querySelector('[data-calc-target="glasses"] .pf-calc__value');
  const resultEl = calcRoot.querySelector('[data-calc-result]');
  const actionsEl = calcRoot.querySelector('[data-calc-actions]');
  const addBtn = calcRoot.querySelector('[data-calc-add]');
  const waBtn = calcRoot.querySelector('[data-calc-wa]');

  let people = 0, glasses = 0, lastKg = 0, lastBags = 0;

  const clamp = n => Math.max(0, Math.min(9999, Number.isFinite(n) ? Math.round(n) : 0));
  const kgFmt = n => n % 1 === 0 ? String(n) : n.toFixed(1).replace('.', ',');

  function update() {
    let kg = 0;
    if (people > 0) {
      kg = people * cfg.kgPerPerson;
      if (glasses) { glasses = 0; glassesInput.value = '0'; }
    } else if (glasses > 0) {
      kg = (glasses * cfg.cubesPerGlass * cfg.gramsPerCube) / 1000;
      if (people) { people = 0; peopleInput.value = '0'; }
    }

    lastKg = Math.max(0, kg);
    lastBags = Math.max(0, Math.ceil(lastKg / Math.max(0.001, bagKg)));
    resultEl.textContent = kgFmt(lastKg);

    if (lastKg > 0) {
      actionsEl && (actionsEl.hidden = false);
      if (addBtn) {
        addBtn.textContent = `Añadir ${lastBags} ${lastBags === 1 ? 'bolsa' : 'bolsas'} al carro`;
      }
      if (waBtn && WA) {
        const msg = `Hola, necesito aprox. ${kgFmt(lastKg)} kg de hielo ${calcType} (${lastBags} ${lastBags === 1 ? 'bolsa' : 'bolsas'} de ${bagKg} kg).`;
        waBtn.href = `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`;
      }
    } else {
      actionsEl && (actionsEl.hidden = true);
    }
  }

  // Steppers
  calcRoot.addEventListener('click', e => {
    const btn = e.target.closest('.pf-calc__step');
    if (!btn) return;
    e.preventDefault();

    const stepper = btn.closest('.pf-calc__stepper');
    const target = stepper.dataset.calcTarget;
    const step = parseInt(btn.dataset.step || '0', 10);

    if (target === 'people') {
      people = clamp((people || 0) + step);
      peopleInput.value = String(people);
      if (people > 0) { glasses = 0; glassesInput.value = '0'; }
    } else {
      glasses = clamp((glasses || 0) + step);
      glassesInput.value = String(glasses);
      if (glasses > 0) { people = 0; peopleInput.value = '0'; }
    }
    update();
  });

  // Input directo
  const sanitize = el => { const n = parseInt(el.value.replace(/\D/g, '') || '0', 10); el.value = String(clamp(n)); return clamp(n); };
  
  [peopleInput, glassesInput].forEach(el => {
    el.addEventListener('keydown', e => { if (e.key === 'Enter') e.preventDefault(); });
  });
  
  peopleInput.addEventListener('input', () => {
    people = sanitize(peopleInput);
    if (people > 0) { glasses = 0; glassesInput.value = '0'; }
    update();
  });
  
  glassesInput.addEventListener('input', () => {
    glasses = sanitize(glassesInput);
    if (glasses > 0) { people = 0; peopleInput.value = '0'; }
    update();
  });

  // Add to cart
  addBtn && addBtn.addEventListener('click', async e => {
    e.preventDefault();
    if (!variantId) return;
    const qty = Math.max(1, lastBags || 1);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: Number(qty) })
      });
      if (!res.ok) throw new Error('add.js failed');
      await res.json();

      // Refrescar contador del carrito
      try {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count')
          .forEach(n => {
            if (n.hasAttribute('data-cart-count')) n.setAttribute('data-cart-count', cart.item_count);
            (n.querySelector('.text') || n).textContent = cart.item_count;
          });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (_) {}

      // Intentar abrir el ATC modal si existe
      if (typeof atc !== 'undefined' && atc.openWithLastAdded) {
        atc.openWithLastAdded(variantId, qty);
      }
    } catch (err) {
      console.error(err);
      if (productUrl) location.href = productUrl;
    }
  });

  update();
})();
